module.exports = __webpack_public_path__ + "img/vaio.f36c5f47.svg";